import { MARQUEE } from "@/data/content";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="relative bg-brand-bordeaux py-5 overflow-hidden border-y border-brand-gold/20" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-serif italic text-xl sm:text-2xl text-brand-ivory/90">
            {t}
            <span className="text-brand-gold not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
